var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "st_swiper" } }, [
    _c("div", { staticClass: "close", on: { click: _vm.close } }),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass: "swiper-container",
          on: { mouseenter: _vm.on_enter, mouseleave: _vm.on_leave },
        },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.list, function (item, index) {
              return item.dataName != 0
                ? _c("div", { key: index, staticClass: "swiper-slide" }, [
                    _c("div", { staticClass: "slide_box" }, [
                      _c("div", {
                        staticClass: "edge",
                        style: _vm._f("edgeColor")(item.imageData),
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "slide_box_main",
                          style: _vm._f("officialBack")(item.imageData),
                        },
                        [
                          _c("div", {
                            staticClass: "swiper_info",
                            attrs: { data: JSON.stringify(item) },
                          }),
                          _c("div", { staticClass: "layer" }, [
                            _c("img", {
                              attrs: { src: item.userIcon, alt: "" },
                            }),
                            _c("p", { staticClass: "hide" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("Prohibited_words")(item.userName)
                                )
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "pic" }, [
                            _c("img", {
                              attrs: { src: item.goodsIcon, alt: "" },
                            }),
                          ]),
                          _c(
                            "div",
                            { staticClass: "item_data" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: item.goodsName,
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c("p", { staticClass: "hide" }, [
                                    _vm._v(_vm._s(item.goodsName)),
                                  ]),
                                ]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("division")(item.dataName))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e()
            }),
            0
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }